export function findFirstRenderRowIndex(_a) {
    var _b = _a.offsetAddon, offsetAddon = _b === void 0 ? 0 : _b, scrollTop = _a.scrollTop, totalCount = _a.totalCount, rowsParams = _a.rowsParams;
    var end = totalCount - 1;
    var start = 0;
    // binary search
    while (start <= end) {
        var idx = Math.floor((start + end) / 2);
        var targetValue = rowsParams[idx];
        var targetOffset = targetValue.topOffset + offsetAddon;
        var offsetToTargetBottom = targetOffset + targetValue.height;
        var isFirstVisibleRow = targetOffset <= scrollTop && offsetToTargetBottom > scrollTop;
        if (isFirstVisibleRow) {
            return idx;
        }
        if (!idx) {
            return 0;
        }
        if (targetOffset > scrollTop) {
            end = idx;
        }
        else {
            start = idx + 1;
        }
    }
    return 0;
}
//# sourceMappingURL=utils.js.map